"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDetailsQuery = exports.orderDetailsByTokenQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const auth_1 = require("../fragments/auth");
const user_1 = require("../fragments/user");
const checkout_1 = require("../fragments/checkout");
exports.orderDetailsByTokenQuery = graphql_tag_1.default`
  ${user_1.orderDetailFragment}
  query OrderByToken($token: UUID!) {
    orderByToken(token: $token) {
      ...OrderDetail
    }
  }
`;
exports.getUserDetailsQuery = graphql_tag_1.default`
  ${auth_1.userFragment}
  ${checkout_1.checkoutFragment}
  query UserDetails {
    me {
      ...User
      checkout {
        ...Checkout
      }
    }
  }
`;
//# sourceMappingURL=user.js.map
